import { Size } from "@core/models/size";

// The PlacementSize is a wrapper of Size with added page's columns and height parameters
// to provide the view model with all necessary data to calc the ratios and decouple ProductPlacementSizeComboService from a component

export class PlacementSize {
	
	label: string;
	columns: number | undefined;
	height: number | undefined;
	moduleCode: string | undefined;
	pageWidthFraction: number;
	pageHeightFraction: number;

	// pageWidthMM: number | undefined;
	// pageColumns: number | undefined;
	// pageHeight: number | undefined;

	constructor (size: Size) {
		this.label = size.label;
		this.columns = size.columns;
		this.height = size.height;
		this.moduleCode = size.moduleCode;
		this.pageWidthFraction = size.pageWidthFraction; 
		this.pageHeightFraction = Math.round(size.pageHeightFraction * 8) / 8; // TODO hack around API bug - round to nearest 1/8
		// this.pageWidthMM = pageWidthMM;
		// this.pageColumns = pageColumns;
		// this.pageHeight = pageHeight;
	}

	// calcWidthMM(): number | undefined {
	// 	if (this.columns === undefined || this.columns === 0 || this.pageColumns === undefined || this.pageColumns === 0 || this.pageWidthMM === undefined || this.pageWidthMM === 0) {
	// 		return undefined;
	// 	}

	// 	return this.columns * this.pageWidthMM / this.pageColumns;
	// }
}
